/**
 * Pad pure-numeric SKU search terms to 5 digits with leading zeros.
 * Non-numeric and 5+ digit terms are returned unchanged.
 */
function normalizeSkuSearchTerm(searchTerm) {
  const trimmed = searchTerm.trim();
  if (/^\d+$/.test(trimmed) && trimmed.length < 5) {
    return trimmed.padStart(5, '0');
  }
  return searchTerm;
}

window.normalizeSkuSearchTerm = normalizeSkuSearchTerm;
